import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'yesNo'
})
export class YesNoPipe implements PipeTransform {

    transform(value: any, ...args: unknown[]): string {
        if (value == null) return '';

        return value === true ? 'Ja' : 'Nein';
    }

}
